export { default as ActivationButton } from './ActivationButton';
export { default as CustomDropDown } from './CustomDropDown';
export { default as CustomTextArea } from './CustomTextArea';
export { default as CustomDatePicker } from './CustomDatePicker';
export { default as CustomInput } from './CustomInput';
export { default as ActionButton } from './ActionButton';
export { default as Error } from './Error';
export { default as CustomError } from './CustomError';
export { default as CustomChipsGroup } from './CustomChipsGroup';
export { default as CustomRadio } from './CustomRadio';
export { default as CustomCollapse } from './CustomCollapse';
export { default as CustomCollapseItem } from './CustomCollapseItem';
export { default as FooterButtons } from './FooterButtons';
export { default as CustomTitleDivider } from './CustomTitleDivider';
export { default as CustomDropDownRounded } from './CustomDropDownRounded';
export { default as CustomTimePicker } from './CustomTimePicker';
export { default as CustomTimeInput } from './CustomTimeInput';
export { default as CustomFileInput } from './CustomFileInput';
export { default as CustomCheckboxSingleOption } from './CustomCheckboxSingleOption';
export { default as CustomBalloon } from './CustomBalloon';
export { default as CustomSeparator } from './CustomSeparator';
export { default as CustomCallout } from './CustomCallout';
export { default as CustomBalloonLight } from './CustomBalloonLight';
export { default as CustomLink } from './CustomLink';
export { default as CustomCheckbox } from './CustomCheckbox';
export { default as CustomToggle } from './CustomToggle';
export { default as CustomColorPicker } from './CustomColorPicker';
export { default as CustomAutoComplete } from './CustomAutoComplete';
export { default as CustomMultiSelect } from './CustomMultiSelect';
export { default as CustomIconView } from './CustomIconView';
export { default as Empty } from './Empty';
export * from './DynamicFormList';

// Lista de colores
const colors = Object.freeze({
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  BROWN: 'brown',
  YELLOW: 'yellow',
  PINK: 'pink',
  VIOLET: 'violet',
  CREAM: 'cream',
  GRAY: 'gray',
  PEACH: 'peach',
  CHARDONNAY: 'chardonnay',
  ORANGE: 'orange',
  LIGHTBLUE: '#deb3d7',
});

export const Colors = colors;
